
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swapi",
      function () {
        return require("private-next-pages/swapi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swapi"])
      });
    }
  